/**
* directives.macros Module
*
* Description
*/
var app = angular.module('directives.macros');
    app.directive('macros', [
            'Authentication',
            '$compile',
            '$timeout',
            '$filter',
            '$parse',
            '$interpolate',
            function (Authentication, $compile, $timeout, $filter, $parse, $interpolate) {

                var getCommission = function (key, scope) {
                    var currKey;
                    for (var i = 0; i < scope.hintFields.length; i++) {
                      if (scope.hintFields[i] == key) {
                        currKey = i;
                        break;
                      }
                    }
                    if (currKey >= 0 && scope.fields[currKey]) {
                        scope.$watch('service.amountWithCommission', function (amountWithCommission) {
                            if (amountWithCommission && scope.paymentscope && scope.service && scope.service.amount) {
                                scope.fields[currKey].value = scope.paymentscope.calcCommission(
                                    amountWithCommission, scope.service.amount
                                );
                            }
                        });
                    }
                };

                var getSum = function (amountValue, scope) {
                    return amountValue;
                };

                var getTotalSum = function (amount, scope) {
                    if (amount && scope.paymentscope) {
                        var commision = scope.paymentscope.calcCommission(scope.service.amountWithCommission, amount);
                        return (new BigNumber(amount || 0).plus(new BigNumber(commision || 0))).toFixed(2);
                    }
                    return 0;
                };

                var getNds = function (value, scope, ndsValue) {
                    var floatVal = parseFloat(value);
                    //var floatResult = isNaN(floatVal) ? new BigNumber(0) : new BigNumber(floatVal).times(ndsValue).div(100);
                    var floatResult = isNaN(floatVal) ? new BigNumber(0) : new BigNumber(floatVal).div(6);
                    return Number(floatResult.round(2, BigNumber.ROUND_HALF_EVEN).toFixed(2));
                };

                var getCurrentDate = function (key, scope) {
                    var date = new Date();
                    for (var i = 0; i < scope.hintFields.length; i++) {
                      if (scope.hintFields[i] == key) {
                        currKey = i;
                        break;
                      }
                    }
                    if (currKey >= 0 && scope.fields[currKey]) {
                        scope.fields[currKey].value = $filter('date')(date, 'dd.MM.yyyy');
                    }
                };

                /**
                 * fires hint's handler function, if it exists,
                 * @method hintTrigger
                 * @param {String} triggerName Name of the hint key
                 * @param {Object} scope
                 * @param {Object} params Transferred value
                 * @return
                 */
                var hintTrigger = function (triggerName, scope, params) {
                    for (var i = 0; i < scope.hintFields.length; i++) {
                      if (scope.hintFields[i] == key) {
                        currKey = i;
                        break;
                      }
                    }
                    if (currKey) {
                        if ((scope.hint[triggerName].handler instanceof Function) && scope.fields[currKey]) {
                            scope.fields[currKey].value = scope.hint[triggerName].handler(
                                params,
                                scope,
                                scope.hint[triggerName].value
                            );
                        }
                    }
                };

                /**
                 * initialization of the hint items
                 * pushing new field items gathered from the hint array
                 * firing the initHandler function of each item it got
                 * @method hintInit
                 * @param {Object} scope
                 * @return
                 */
                var hintInit = function (scope) {
                    var fieldLen = null;
                    _(scope.hint).each(function (val, key) {
                        if (scope.service.destinationTemplate.indexOf(key) >= 0) {

                            scope.fields.push({
                                name: key,
                                type: val.type,
                                data: val
                            });
                            fieldLen = (scope.fields.length - 1);
                            scope.hint[key].fieldKey = fieldLen;
                            scope.hintFields[fieldLen] = key;
                            if (scope.hint[key].initHandler instanceof Function) {
                                scope.hint[key].initHandler(key, scope);
                            }
                            if (scope.hint[key].watcher instanceof Function) {
                                scope.hint[key].watcher(key, scope);
                            }
                        }
                    });
                };

                return {
                    restrict: 'E',
                    replace: true,
                    require: '^ngModel',
                    scope: {
                        fields: '=',
                        service: '=',
                        editable: '=',
                        formcontroller: '=',
                        paymentscope: '='
                    },
                    template: '<div class="macros" ng-change="update()" contenteditable="{{editable}}"></div>',
                    controller: [
                        '$scope',
                        function ($scope) {
                            $scope.hintFields = []; // chain scope.fields and scope.hint elements: { fieldNumber: hintKey}
                            $scope.hint = { // possible hint elements
                                nds: {
                                    handler: getNds,
                                    value: 16.67,
                                    type: 'hidden'
                                },
                                date_current: {
                                    initHandler: getCurrentDate,
                                    value: null,
                                    type: 'hidden'
                                },
                                payment_sum: {
                                    handler: getSum,
                                    value: null,
                                    type: 'hidden'
                                },
                                commission_sum: {
                                    watcher: getCommission,
                                    value: null,
                                    type: 'hidden'
                                },
                                payment_id: {
                                    value: null,
                                    type: 'hidden'
                                },
                                total_sum: {
                                    handler: getTotalSum,
                                    value: null,
                                    type: 'hidden'
                                }
                            };
                            hintInit($scope);
                        }
                    ],
                    link: function (scope, element, attrs, ngModelCtrl) {

                        scope.$watch('service.destinationTemplate', function (destinationTemplate) {
                            // scope.service.destination = '';

                            var macrosStr = destinationTemplate.replace((/\{\{/g), '[[').replace((/\}\}/g), ']]');
                            var fio = Authentication.user.name;
                            var arr = fio.split(' ');
                            arr[1] = arr[1].substr(0, 1).toUpperCase() + '.';
                            arr[2] = arr[2].substr(0, 1).toUpperCase() + '.';
                            var fio_sm = arr.join(' ');

                            scope.fields.push({
                                name: 'client_fio',
                                value: fio,
                                restriction: 'INV'
                            }, {
                                name: 'client_fio_sm',
                                value: fio_sm,
                                restriction: 'INV'
                            });

                            for (field in scope.fields) {
                                var fieldNameRegExp = new RegExp('\\[\\[' + field.name + '\\]\\]');
                                if (macrosStr.search(fieldNameRegExp) !== -1) {
                                    macrosStr = macrosStr.replace(fieldNameRegExp, '{{fields[' + scope.fields[field] + '].value}}');
                                }
                            };
                            element.html($compile('<span>' + macrosStr.replace(/\[\[.+\]\]/g, '') + '</span>')(scope));
                        });

                        element.on('keydown', function () {
                            scope.updateModel();
                            scope.formcontroller.destination.$dirty = true;
                        });

                        scope.updateModel = function () {
                            $timeout(function () {
                                ngModelCtrl.$setViewValue($.trim(element.text()));
                            });
                        };

                        scope.$watch('fields', function (fields) {
                            scope.updateModel();
                        }, true);

                        scope.$watch('service.amount', function (newValue, oldValue) {
                            newValue = (newValue) ? newValue : '';
                            hintTrigger('nds', scope, newValue);
                            hintTrigger('payment_sum', scope, newValue);
                            hintTrigger('total_sum', scope, newValue);
                        }, true);
                    }
                };
            }
        ]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/macros/macros.directive.js
 ** module id = 175
 ** module chunks = 1
 **/